module.exports = __webpack_public_path__ + "src/img/artist/work01_1.jpg?b090cb0455352efc296f2e2c709dd043";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work01_1.jpg
// module id = 147
// module chunks = 0